<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="50%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <div class="table">
        <el-form
          ref="createForm"
          class="header"
          :model="createForm"
          :rules="creatRules"
          label-width="100px"
        >
          <el-form-item
            label="课程表名称"
            prop="courseScheduleName"
          >
            <el-input v-model="createForm.courseScheduleName" />
          </el-form-item>
        </el-form>
        <el-table
          :data="dateList"
          border
        >
          <el-table-column
            label="日期"
            width="180px"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="choose-date"
              >
                <el-date-picker
                  v-model="scope.row.scheduleDate"
                  type="date"
                  :clearable="false"
                  placeholder="选择日期"
                  value-format="timestamp"
                  @change="dataPickerChange(scope.row.scheduleDate,scope.$index)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="amContent"
            label="上午"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ formatContent(scope.row.amContent) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pmContent"
            label="下午"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="item">
                <span>{{ formatContent(scope.row.pmContent) }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'ScheduleTplDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Object],
      default: () => ({ courseScheduleName: null, dateList: [], id: null }),
    },
    courseId: {
      type: Number,
    },
  },
  data() {
    return {
      title: '课程表编辑',
      cancelText: '取消',
      dateList: [],
      createForm: {
        courseScheduleName: null,
      },
      creatRules: {
        courseScheduleName: [
          { required: true, message: '请输入课程表名称', trigger: 'blur' },
        ],
      },
    };
  },

  watch: {
    data(value) {
      const data = this._.cloneDeep(value.dateList);
      this.createForm.courseScheduleName = value.courseScheduleName;
      if (data) {
        this.dateList = data.map((v) => Object.assign(v, { scheduleDate: v.scheduleDate ? v.scheduleDate : null }));
      }
    },
  },
  methods: {
    // 选择时间之后自动计算下面的日期
    dataPickerChange(timestamp, index) {
      this.dateList.forEach((item, dateIndex) => {
        if (dateIndex >= index) {
          this.$set(item, 'scheduleDate', this.$time(timestamp).add(dateIndex - index, 'day'));
        }
      });
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    async confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const dateList = this.dateList.map((v) => ({ dateIndexId: v.dateIndexId, scheduleDate: v.scheduleDate }));
          const data = await axClient.course.upsertSchedule({
            courseId: this.courseId,
            id: this.data.id,
            courseScheduleName: this.createForm.courseScheduleName,
            dateList,
          });
          if (!data) return;
          this.$message.success('编辑课程表成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    formatContent(item) {
      if (this.data.courseScheduleName === null) {
        if (item && item.chapterList) {
          return item.chapterList.map((v) => v.chapterName).join(',');
        }
      } else if (item) {
        return item.classContent ? item.classContent : '无';
      }
      return '无';
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: space-between;
  min-height: 200px;
  .table {
    flex: 2;
    .header {
      width: 80%;
      margin-left: 8%;
    }
    ::v-deep .el-table__row {
      &:hover {
        .delete {
          width: 50px;
        }
      }
    }
    ::v-deep {
      .choose-date {
        display: flex;
        justify-content: center;
        .el-input {
          width: 120px;
        }
        span {
          color: $--base-color-main;
        }
        input {
          border: none;
          width: 160px;
          background: transparent;
          color: $--base-color-main;
          cursor: pointer;
          &::placeholder {
            color: $--base-color-main;
          }
        }
      }
    }
  }
}
</style>
